export const TECHNICAL_ISSUE_TYPES = [
  "voice_quality",
  "audio_file_format",
  "voice_model",
  "platform_access",
  "other",
] as const;

export type TechnicalIssueType = (typeof TECHNICAL_ISSUE_TYPES)[number];

export const CATEGORIES = [
  "general",
  "technical",
  "billing",
  "subscription",
  "enterprise",
  "feedback",
  "other",
] as const;

export type ContactCategory = (typeof CATEGORIES)[number];
